import React from "react";
import { View, StyleSheet } from "react-native";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import MaterialIcon from "@expo/vector-icons/MaterialCommunityIcons";

import HomeScreen from "../screens/Home/HomeScreen";
import ProfileScreen from "../screens/Profile/ProfileScreen";
import FloatingButton from "../components/Buttons/FloatingButton";
import ReportScreen from "../screens/TimeTracking/ReportScreen";
import RequestEntryApprovalScreen from "../screens/Request/RequestEntryApprovalScreen";

const Tab = createBottomTabNavigator();

type TabItem = {
  name: string;
  icon?: string;
  label?: string;
  component?: React.ComponentType;
  header?: () => JSX.Element;
  isCenter?: boolean;
};

const tabItems: TabItem[] = [
  {
    name: "Home",
    icon: "home-outline",
    label: "Home",
    component: HomeScreen,
  },
  {
    name: "Report",
    icon: "notebook",
    label: "Report",
    component: ReportScreen,
  },
  {
    name: "Request",
    icon: "briefcase-search",
    label: "Request",
    component: RequestEntryApprovalScreen,
  },
  {
    name: "Profile",
    icon: "account-outline",
    label: "Perfil",
    component: ProfileScreen,
  },
];

// Insert floating tab in the middle (index = middle of tabItems)
const midIndex = Math.ceil(tabItems.length / 2);
const dynamicTabs = [
  ...tabItems.slice(0, midIndex),
  { name: "TimeTracking", isCenter: true },
  ...tabItems.slice(midIndex),
];


const BottomTabs: React.FC = () => {
  return (
    <Tab.Navigator
      screenOptions={({ route }) => {
        const item = tabItems.find((i) => i.name === route.name);

        return {
          tabBarIcon: ({ color, focused }) =>
            item ? (
              <View>
                <MaterialIcon name={(item.icon || "help-circle-outline") as keyof typeof MaterialIcon.glyphMap} size={24} color={color} />
              </View>
            ) : null,
          tabBarShowLabel: true,
          tabBarStyle: {
            backgroundColor: "#fff",
            borderTopWidth: 1,
            borderTopColor: "rgba(0, 0, 0, 0.1)",
            elevation: 10,
            height: 75,
            position: "absolute",
            paddingTop: 10,
          },
          tabBarActiveTintColor: "#0f8ff9",
          tabBarInactiveTintColor: "#aaa",
          headerShown: false,
        };
      }}
    >
      {dynamicTabs.map((tab, index) => {
        if (tab.isCenter) {
          return (
            <Tab.Screen
              key="TimeTracking"
              name="TimeTracking"
              component={() => null}
              options={{
                tabBarButton: () => <FloatingButton />,
                tabBarLabel: () => null,
              }}
              listeners={{
                tabPress: (e) => e.preventDefault(),
              }}
            />
          );
        }

        return (
          <Tab.Screen
            key={tab.name}
            name={tab.name}
            component={tab.component || (() => <View />)}
          />
        );
      })}
    </Tab.Navigator>
  );
};

const styles = StyleSheet.create({
  floatingButton: {
    backgroundColor: "#8DB628",
    width: 70,
    height: 70,
    borderRadius: 35,
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: 0, // anchor to the bottom of the tab bar
    alignSelf: "center",
    transform: [{ translateY: -45 }], // half of height to raise it
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.3,
    shadowRadius: 6,
    elevation: 8,
    zIndex: 100,
  },
  tabIconFocused: {
    color: "#8db62821",
  },
  tabLabel: {
    fontSize: 12,
    marginTop: 3,
    fontWeight: "500",
    backgroundColor: "red",
  },
});

export default BottomTabs;
